import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import UserNavbar from "components/UserNavbar/UserNavbar";
import React from "react";
import {
  FaPaw,
  FaDog,
  FaCat,
  FaClipboardCheck,
  FaPlane,
  FaShieldAlt,
  FaFirstAid,
  FaShip,
  FaHeartbeat,
  FaSuitcase,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaRegCalendarCheck,
  FaTag,
  FaUtensils,
  FaHome
} from "react-icons/fa";
import {
  MdHealthAndSafety,
  MdAirlineSeatReclineExtra,
  MdWarning,
  MdAccessTime,
  MdLocalHospital,
  MdCheckCircle,
  MdPets,
  MdFlightTakeoff,
  MdInfo
} from "react-icons/md";
import { GiMedicines } from "react-icons/gi";

export default function Travelwithpets() {
  const tips = [
    {
      title: "Visit to the Veterinarian",
      icon: <MdHealthAndSafety className="w-6 h-6" />,
      color: "from-green-500 to-emerald-600",
      bgColor: "bg-green-50",
      borderColor: "border-green-200",
      points: [
        {
          text: "Schedule an appointment with your veterinarian well in advance of your planned travel date.",
          icon: <FaRegCalendarCheck className="w-4 h-4 text-green-600" />
        },
        {
          text: "Discuss your intention to travel internationally with your pet and inquire about any specific health considerations for the destination country.",
          icon: <FaMapMarkerAlt className="w-4 h-4 text-green-600" />
        },
        {
          text: "Ensure your pet is up-to-date on all required vaccinations, including rabies, and obtain a health certificate from your veterinarian.",
          icon: <FaClipboardCheck className="w-4 h-4 text-green-600" />
        },
        {
          text: "Discuss microchipping options with your vet if required by the destination country.",
          icon: <FaTag className="w-4 h-4 text-green-600" />
        },
        {
          text: "Inquire about any quarantine requirements or import permits necessary for traveling with your pet to the destination country.",
          icon: <MdWarning className="w-4 h-4 text-green-600" />
        }
      ],
      checklist: [
        "Health certificate",
        "Vaccination records",
        "Microchip verification",
        "Import permits",
        "Quarantine information"
      ]
    },
    {
      title: "Research on Flying with a Pet",
      icon: <FaPlane className="w-6 h-6" />,
      color: "from-blue-500 to-cyan-600",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200",
      points: [
        {
          text: "Research the pet travel policies of airlines that operate flights to your destination.",
          icon: <MdFlightTakeoff className="w-4 h-4 text-blue-600" />
        },
        {
          text: "Understand the specific requirements and restrictions imposed by each airline regarding pet travel, including documentation, carrier specifications, and fees.",
          icon: <FaClipboardCheck className="w-4 h-4 text-blue-600" />
        },
        {
          text: "Consider factors such as the length of the flight, layovers, and temperature restrictions, especially if your pet will travel in the cargo hold.",
          icon: <MdAccessTime className="w-4 h-4 text-blue-600" />
        },
        {
          text: "Check whether the airline has restrictions on specific breeds or types of pets and whether your pet meets the airline's criteria for travel.",
          icon: <FaDog className="w-4 h-4 text-blue-600" />
        }
      ],
      warning: "Some airlines have breed restrictions and temperature embargoes. Always confirm policies 48 hours before travel."
    },
    {
      title: "Airline Restrictions",
      icon: <MdWarning className="w-6 h-6" />,
      color: "from-amber-500 to-orange-600",
      bgColor: "bg-amber-50",
      borderColor: "border-amber-200",
      points: [
        {
          text: "Different airlines have varying policies and restrictions regarding pet travel.",
          icon: <FaPlane className="w-4 h-4 text-amber-600" />
        },
        {
          text: "Some airlines may have specific requirements for pet carriers, including size, material, and ventilation.",
          icon: <FaSuitcase className="w-4 h-4 text-amber-600" />
        },
        {
          text: "Be aware of any additional fees associated with pet travel, such as pet transport fees or excess baggage charges.",
          icon: <FaTag className="w-4 h-4 text-amber-600" />
        },
        {
          text: "Research airlines with established pet travel programs and safety records to minimize the risk associated with pet travel.",
          icon: <FaShieldAlt className="w-4 h-4 text-amber-600" />
        }
      ],
      note: "Carrier dimensions typically range from 18\" x 11\" x 11\" to 22\" x 14\" x 9\" for cabin travel."
    },
    {
      title: "Pet Comfort",
      icon: <MdAirlineSeatReclineExtra className="w-6 h-6" />,
      color: "from-purple-500 to-indigo-600",
      bgColor: "bg-purple-50",
      borderColor: "border-purple-200",
      points: [
        {
          text: "Choose a suitable pet carrier that provides enough space for your pet to stand, turn around, and lie down comfortably.",
          icon: <FaHome className="w-4 h-4 text-purple-600" />
        },
        {
          text: "Familiarize your pet with the carrier in advance of the trip to reduce stress and anxiety.",
          icon: <MdPets className="w-4 h-4 text-purple-600" />
        },
        {
          text: "Pack familiar items such as blankets, toys, and treats to comfort your pet during travel.",
          icon: <FaUtensils className="w-4 h-4 text-purple-600" />
        },
        {
          text: "Provide access to food, water, and bathroom breaks as needed, especially during long flights or layovers.",
          icon: <FaUtensils className="w-4 h-4 text-purple-600" />
        }
      ],
      tips: [
        "Practice with carrier 2-3 weeks before travel",
        "Include favorite toy or blanket",
        "Use pheromone sprays for anxiety",
        "Schedule feeding 4 hours before flight"
      ]
    },
    {
      title: "Cruise Ships and Travel by Sea",
      icon: <FaShip className="w-6 h-6" />,
      color: "from-teal-500 to-cyan-600",
      bgColor: "bg-teal-50",
      borderColor: "border-teal-200",
      points: [
        {
          text: "If traveling by sea, research the pet policies of the cruise line or ferry service you plan to use.",
          icon: <FaShip className="w-4 h-4 text-teal-600" />
        },
        {
          text: "Check whether pets are allowed onboard and whether designated pet-friendly accommodations are available.",
          icon: <FaDog className="w-4 h-4 text-teal-600" />
        },
        {
          text: "Ensure compliance with any documentation or vaccination requirements for pets traveling by sea, and inquire about any restrictions on pet access to specific areas of the ship.",
          icon: <FaClipboardCheck className="w-4 h-4 text-teal-600" />
        }
      ],
      note: "Most major cruise lines have limited pet cabins and strict health requirements. Book well in advance."
    },
    {
      title: "High-Risk Companies and Illness/Death of Pet",
      icon: <FaHeartbeat className="w-6 h-6" />,
      color: "from-red-500 to-pink-600",
      bgColor: "bg-red-50",
      borderColor: "border-red-200",
      points: [
        {
          text: "Research and choose reputable transportation companies with established pet travel programs and safety records.",
          icon: <FaShieldAlt className="w-4 h-4 text-red-600" />
        },
        {
          text: "Consider factors such as the company's experience with pet travel, safety protocols, and customer reviews.",
          icon: <MdCheckCircle className="w-4 h-4 text-red-600" />
        },
        {
          text: "Be aware of the potential risks associated with pet travel, including stress, injury, illness, or death, and take necessary precautions to minimize these risks.",
          icon: <MdWarning className="w-4 h-4 text-red-600" />
        },
        {
          text: "Have a contingency plan in case of emergencies or unexpected events during travel, including access to veterinary care or pet insurance coverage.",
          icon: <FaFirstAid className="w-4 h-4 text-red-600" />
        }
      ],
      important: "Pet travel insurance is highly recommended for international trips. Coverage varies by provider."
    },
    {
      title: "Emergency Preparedness",
      icon: <FaFirstAid className="w-6 h-6" />,
      color: "from-rose-500 to-pink-600",
      bgColor: "bg-rose-50",
      borderColor: "border-rose-200",
      points: [
        {
          text: "Carry a pet first aid kit with essential supplies such as medications, bandages, and emergency contact information.",
          icon: <GiMedicines className="w-4 h-4 text-rose-600" />
        },
        {
          text: "Research veterinary clinics or emergency services at your destination in case your pet requires medical attention.",
          icon: <MdLocalHospital className="w-4 h-4 text-rose-600" />
        },
        {
          text: "Keep copies of your pet's medical records, vaccination certificates, and identification tags with you during travel.",
          icon: <FaClipboardCheck className="w-4 h-4 text-rose-600" />
        },
        {
          text: "Consider purchasing pet travel insurance to provide coverage for unexpected expenses related to your pet's health or well-being.",
          icon: <FaShieldAlt className="w-4 h-4 text-rose-600" />
        }
      ],
      checklist: [
        "First aid kit",
        "Emergency vet contacts",
        "Digital copies of documents",
        "Pet insurance info",
        "24/7 emergency number"
      ]
    },
  ];

  return (
    <section className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <UserNavbar />
      <ScrollToTopOnRouteChange />

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 opacity-90"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="md:w-2/3">
              <div className="flex items-center gap-4 mb-6">
                <div className="p-3 rounded-full bg-white/20 backdrop-blur-sm">
                  <FaPaw className="w-10 h-10 text-white" />
                </div>
                <div className="p-3 rounded-full bg-white/20 backdrop-blur-sm">
                  <FaDog className="w-10 h-10 text-white" />
                </div>
                <div className="p-3 rounded-full bg-white/20 backdrop-blur-sm">
                  <FaCat className="w-10 h-10 text-white" />
                </div>
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                Traveling with Pets
              </h1>
              <p className="text-xl text-blue-100 mb-8 max-w-3xl">
                Your comprehensive guide to safe and comfortable international travel with your furry companions. Let's make every journey pawsitive!
              </p>
              <div className="flex flex-wrap gap-4">
                <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white text-sm flex items-center gap-2">
                  <MdCheckCircle className="w-4 h-4" /> Pet-Friendly Airlines
                </span>
                <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white text-sm flex items-center gap-2">
                  <MdCheckCircle className="w-4 h-4" /> Health Requirements
                </span>
                <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-white text-sm flex items-center gap-2">
                  <MdCheckCircle className="w-4 h-4" /> Safety Tips
                </span>
              </div>
            </div>
            <div className="md:w-1/3">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <h3 className="text-xl font-semibold text-white mb-4">Quick Checklist</h3>
                <ul className="space-y-3">
                  {[
                    "Vet check-up ✓",
                    "Updated vaccinations ✓",
                    "Health certificate ✓",
                    "Pet carrier ✓",
                    "Travel documents ✓",
                    "Emergency kit ✓"
                  ].map((item, index) => (
                    <li key={index} className="flex items-center gap-3 text-white">
                      <div className="w-6 h-6 rounded-full bg-green-400 flex items-center justify-center">
                        <MdCheckCircle className="w-4 h-4 text-white" />
                      </div>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute -bottom-10 left-10 w-40 h-40 bg-yellow-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
        <div className="absolute top-10 right-10 w-60 h-60 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Introduction */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Essential Tips for Traveling with Your Pets
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Follow this step-by-step guide to ensure a smooth and stress-free journey for both you and your pet. 
            Each section contains crucial information to prepare for international travel.
          </p>
        </div>

        {/* Main Content */}
        <div className="space-y-8">
          {tips.map((tip, index) => (
            <div
              key={index}
              id={`tip-${index + 1}`}
              className="scroll-mt-24"
            >
              <div className={`rounded-2xl shadow-lg overflow-hidden border ${tip.borderColor} transition-all duration-300 hover:shadow-xl hover:-translate-y-1`}>
                {/* Header */}
                <div className={`bg-gradient-to-r ${tip.color} p-6 md:p-8`}>
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                        <div className="text-white">
                          {tip.icon}
                        </div>
                      </div>
                      <div>
                        <div className="flex items-center gap-3">
                          <span className="text-white/80 text-sm font-semibold bg-white/20 px-3 py-1 rounded-full">
                            Step {index + 1}
                          </span>
                          <h3 className="text-2xl md:text-3xl font-bold text-white">
                            {tip.title}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="text-white/90">
                      <div className="flex items-center gap-2">
                        <FaPaw className="w-5 h-5" />
                        <span className="text-sm font-semibold">Essential</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className={`${tip.bgColor} p-6 md:p-8`}>
                  <div className="grid lg:grid-cols-2 gap-8">
                    {/* Points */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <MdCheckCircle className="w-5 h-5" />
                        Key Actions
                      </h4>
                      <ul className="space-y-4">
                        {tip.points.map((point, pointIndex) => (
                          <li key={pointIndex} className="flex items-start gap-3">
                            <div className="flex-shrink-0 mt-1">
                              {point.icon}
                            </div>
                            <p className="text-gray-700">{point.text}</p>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Additional Info */}
                    <div>
                      {tip.checklist && (
                        <>
                          <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                            <FaClipboardCheck className="w-5 h-5" />
                            Required Documents & Items
                          </h4>
                          <div className="space-y-3">
                            {tip.checklist.map((item, idx) => (
                              <div key={idx} className="flex items-center gap-3 p-3 bg-white rounded-lg">
                                <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
                                  <MdCheckCircle className="w-4 h-4 text-green-600" />
                                </div>
                                <span className="text-gray-700">{item}</span>
                              </div>
                            ))}
                          </div>
                        </>
                      )}

                      {tip.tips && (
                        <>
                          <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                            <FaPaw className="w-5 h-5" />
                            Pro Tips
                          </h4>
                          <div className="space-y-3">
                            {tip.tips.map((item, idx) => (
                              <div key={idx} className="flex items-center gap-3 p-3 bg-white rounded-lg">
                                <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center">
                                  <FaDog className="w-4 h-4 text-blue-600" />
                                </div>
                                <span className="text-gray-700">{item}</span>
                              </div>
                            ))}
                          </div>
                        </>
                      )}

                      {(tip.warning || tip.note || tip.important) && (
                        <div className={`mt-6 p-4 rounded-lg border ${tip.borderColor} bg-white`}>
                          <div className="flex items-start gap-3">
                            {tip.warning ? (
                              <MdWarning className="w-6 h-6 text-amber-500 flex-shrink-0" />
                            ) : tip.important ? (
                              <FaHeartbeat className="w-6 h-6 text-red-500 flex-shrink-0" />
                            ) : (
                              <MdInfo className="w-6 h-6 text-blue-500 flex-shrink-0" />
                            )}
                            <div>
                              <h5 className="font-semibold text-gray-800 mb-1">
                                {tip.warning ? 'Important Warning' : tip.important ? 'Critical Note' : 'Additional Information'}
                              </h5>
                              <p className="text-gray-600 text-sm">
                                {tip.warning || tip.note || tip.important}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="bg-white border-t p-4">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <FaPaw className="w-4 h-4" />
                      <span>Travel Preparation</span>
                    </div>
                    <div className="text-sm text-gray-500">
                      Priority: {index < 2 ? "High" : index < 4 ? "Medium" : "Standard"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Contact Banner */}
        <div className="mt-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="md:w-2/3">
              <div className="flex items-center gap-3 mb-4">
                <FaPhoneAlt className="w-8 h-8" />
                <h3 className="text-2xl font-bold">Need Help with Pet Travel?</h3>
              </div>
              <p className="text-blue-100">
                Our travel consultants are experienced in handling pet travel arrangements and can guide you through the entire process.
              </p>
            </div>
            <div className="md:w-1/3 text-center">
              <button className="bg-white text-blue-600 hover:bg-blue-50 font-semibold py-3 px-8 rounded-full transition-all duration-300 transform hover:scale-105">
                Contact Pet Travel Specialist
              </button>
              <p className="text-sm text-blue-100 mt-2">
                Available 24/7 for emergencies
              </p>
            </div>
          </div>
        </div>

        {/* Additional Resources */}
        <div className="mt-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Additional Resources</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl border border-gray-200 hover:border-blue-300 transition-colors">
              <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                <FaClipboardCheck className="w-6 h-6 text-blue-600" />
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Document Checklist</h4>
              <p className="text-gray-600 text-sm">
                Download our comprehensive checklist for pet travel documentation
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border border-gray-200 hover:border-green-300 transition-colors">
              <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center mb-4">
                <MdLocalHospital className="w-6 h-6 text-green-600" />
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Vet Directory</h4>
              <p className="text-gray-600 text-sm">
                Find certified pet travel veterinarians near you
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border border-gray-200 hover:border-purple-300 transition-colors">
              <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center mb-4">
                <FaShieldAlt className="w-6 h-6 text-purple-600" />
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Pet Insurance</h4>
              <p className="text-gray-600 text-sm">
                Compare travel insurance options for your pet
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}